const formDataGroup = {
  setting_type: 'weekly',
  type: 'file',
  file: null,
  start_working_time: null,
  end_working_time: null,
  start_outworking_time: null,
  end_outworking_time: null,
  days_of_week: { monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6, sunday: 7 },
  phone_transfer: null,
  day: null
}

const state = {
  isShow: false,
  dataSetting: {},
  dataSettingOuttime: [],
  dataHolidayCurrent: [],
  dataDeleteOuttime: [],
  defaultOption: false,
  formDataGroup: {
    setting_type: 'weekly',
    type: 'file',
    file: null,
    start_working_time: null,
    end_working_time: null,
    start_outworking_time: null,
    end_outworking_time: null,
    days_of_week: { monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6, sunday: 7 },
    phone_transfer: null,
    day: null
  },
  reloadOuttime: false,
  editSettingBusinessComplete: false
}
const getters = {
  isShow(state) {
    return state.isShow
  },
  dataSetting(state) {
    return state.dataSetting
  },
  dataSettingOuttime(state) {
    return state.dataSettingOuttime
  },
  dataHolidayCurrent(state) {
    return state.dataHolidayCurrent
  },
  dataDeleteOuttime(state) {
    return state.dataDeleteOuttime
  },
  dataDefaultOption(state) {
    return state.defaultOption
  },
  dataReloadOutime(state) {
    return state.reloadOuttime
  },
  formDataGroup(state) {
    return state.formDataGroup
  },
  editSettingBusinessComplete(state) {
    return state.editSettingBusinessComplete
  }
}

const mutations = {
  OPEN_POPUP(state, dataPopup) {
    state.isShow = true
    state.dataSetting = dataPopup
  },
  DEFAULT_OPTION(state, data) {
    state.defaultOption = data
  },
  CLOSE_POPUP(state) {
    state.isShow = false
    state.dataSetting = {}
    state.formDataGroup = { ...formDataGroup }
  },
  EDIT_COMPLETE(state) {
    state.editSettingBusinessComplete = !state.editSettingBusinessComplete
  },
  UPDATE_DATASETTING_OUTTIME (state, data) {
    state.dataSettingOuttime = data
  },
  HOLIDAY_CURRENT (state, data) {
    state.dataHolidayCurrent = [
      {
        id: null,
        name: '-'
      }
    ]
    if (Object.keys(data).length) {
      state.dataHolidayCurrent = [data]
    }
  },
  DELETE_OUTTIME(state, data) {
    state.dataDeleteOuttime = data
  },
  RELOAD_OUTTIME(state, data) {
    state.reloadOuttime = !state.reloadOuttime
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
